var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6758 10.5L8.00917 2.33333C7.90741 2.15379 7.75985 2.00444 7.58154 1.90054C7.40323 1.79664 7.20054 1.74189 6.99417 1.74189C6.78779 1.74189 6.58511 1.79664 6.40679 1.90054C6.22848 2.00444 6.08092 2.15379 5.97917 2.33333L1.3125 10.5C1.20965 10.6781 1.15572 10.8803 1.15617 11.086C1.15663 11.2917 1.21145 11.4936 1.31509 11.6712C1.41873 11.8489 1.5675 11.996 1.74632 12.0977C1.92514 12.1993 2.12765 12.2519 2.33333 12.25H11.6667C11.8714 12.2498 12.0724 12.1957 12.2496 12.0932C12.4268 11.9908 12.5739 11.8435 12.6761 11.6661C12.7784 11.4888 12.8322 11.2877 12.8321 11.083C12.8321 10.8783 12.7782 10.6773 12.6758 10.5Z",
    stroke: "#D32F2F",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 5.25V7.58333",
    stroke: "#D32F2F",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 9.91667H7.00583",
    stroke: "#D32F2F",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.8ee0ae14f5123f5de6d3cfd83ae43054.svg";
export { ForwardRef as ReactComponent };